import React, { useContext } from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
  ImageField,
  LinkFieldValue,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { ResponsiveImage, ResponsiveImageProps } from '../../ResponsiveImage/ResponsiveImage';
import { getSubscriptionModeCookie } from '../../../utils/authHelper';
import { SubscriptionMode } from '../SubscriptionValidation/SubscriptionValidation';

export type SubscriptionLogoProps = WithSitecoreContextProps & {
  fields: {
    'Logo Image': ImageField;
    'Mobile Logo Image': ImageField;
    Link: Field<LinkFieldValue>;
  };
  params: {
    Direction: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export const SubscriptionLogo = ({
  fields,
  sitecoreContext,
}: SubscriptionLogoProps): React.JSX.Element => {
  if (getSubscriptionModeCookie() !== SubscriptionMode.Subscribed) {
    return <div className="subscription-logo"></div>;
  }

  if (fields) {
    let imageObj: ResponsiveImageProps = {
      responsiveFields: {
        MobileImageSrc: fields['Mobile Logo Image'],
        DesktopImageSrc: fields['Logo Image'],
      },
      sitecoreContext: sitecoreContext,
    };

    return (
      <div className="subscription-logo">
        {
          <>
            <a
              href={fields.Link?.value?.href}
              target={fields.Link?.value?.target}
              title={fields.Link?.value?.title}
              className="logoLink"
            >
              <ResponsiveImage
                responsiveFields={imageObj.responsiveFields}
                sitecoreContext={imageObj.sitecoreContext}
              />
            </a>
          </>
        }
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(SubscriptionLogo);
